export default __webpack_public_path__ + "static/qfb-271cb02ca7bc26bce488d29e19e6b122.png";